import React, {Component} from "react";
import {Form, InputNumber, Modal} from "antd";

class ProcessSubmit extends Component {

    onOk = () => {
        const {form, onOk} = this.props;
        form.validateFields((error, fieldsValue) => {
            if (!error) {
                onOk(fieldsValue)
            }
        })
    };

    render() {
        const {getFieldDecorator} = this.props.form
        return (
            <Modal {...this.props}
                   onOk={this.onOk}
                   destroyOnClose={true}
            >
                <Form.Item label={'数量'}>
                    {getFieldDecorator('qty', {
                        rules: [{
                            required: true, message: '请输入汇报数量', validator: (rule, value, callback) => {
                                if (!value || parseInt(value) <= 0) callback('')
                                else callback()
                            }
                        }],
                        initialValue: null
                    })(
                        <InputNumber style={{width: '100%'}}
                                     min={0}
                                     step={1}
                                     precision={0} />
                    )}
                </Form.Item>
            </Modal>
        );
    }
}

export default Form.create()(ProcessSubmit);